module.exports = __webpack_public_path__ + "images/default-fallback-image.png";